export default {"src":"/_next/static/media/Zen EX.6689d158.svg","height":312,"width":313,"blurWidth":0,"blurHeight":0};